import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../setup'
import {ADMIN_ROLE, hasRole} from './TokenUtils'

/** Oturumdaki kullanıcının verilen rolü var mı (menü ve ekran görünürlüğü için) */
export function useHasRole(role: string): boolean {
  const accessToken = useSelector<RootState, string | undefined>(
    ({auth}) => auth.accessToken,
    shallowEqual
  )
  return hasRole(accessToken, role)
}

export function useIsAdmin(): boolean {
  return useHasRole(ADMIN_ROLE)
}
